// extracted by mini-css-extract-plugin
module.exports = {"body":"_1c3RTS1tVJw_mOxShbU8Kn","dialog":"_2LBl4OkfVKaGrVbn8YJFf2","danger":"_2opviX5kGYWlnS04rXgD2X"};